/*
  NOTE:
  This currently has a memory leak if the user uploads a file and deletes it before it gets to the data layer.
  The current desired behaviour is that it only deletes files in the fileDb when saving to redux. However we
  need to make sure that if a user uplaods a file and deletes it before anything is saved to redux, it gets
  deleted here. We can do this by tracking new files within this component
*/

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  fileDb,
  newInternalId,
} from 'AppSrc/core/utility-storage/file-db';
import { REMEDY_UPLOAD } from 'AppSrc/core/components/forms/form-types/create-crq/section-five/work-information-items/work-information-item-constants';
import { DropzoneArea } from './sub-components/dropzone-area';
import { InlineErrors } from './sub-components/inline-errors';
import { FieldTitle } from './sub-components/field-title';
import {
  vFParamsPropShape,
  disabledFieldOptionsShape,
} from './data-structure/v-f-proptypes';
import {
  getFieldPropShape,
  formPropShape,
} from './data-structure/formik-proptypes';
import 'AppSrc/core/style/components/form/form-base-components/v-f-dropzone.css';



class VFDropzone extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      CrqID: '',
    };
    this.onFileAdded = this.onFileAdded.bind(this);
    this.onFileRemoved = this.onFileRemoved.bind(this);
    this.ButtonCheck = this.ButtonCheck.bind(this);
  }

  componentDidMount() {
    this.ifDisabledSetDefaultValues({});
  }

  componentDidUpdate(prevProps) {
    this.ifDisabledSetDefaultValues({
      prevProps,
    });
  }

  onFileAdded(file) {
    const {
      field,
    } = this.props;

    const {
      name,
      value,
    } = field;

    const fileId = value ? value.fileId : newInternalId();
    const fileName = file.name;

    const fileObj = {
      fileName: file.name,
      file,
    };

    fileDb.save({
      id: fileId,
      file: fileObj,
    });

    const newValue = {
      fileName,
      fileId,
    };

    this.props.form.setFieldValue(name, newValue);
    this.props.form.setFieldTouched(name, true);

    return null;
  }

  onFileRemoved() {
    const {
      field,
    } = this.props;


    const {
      name,
      value,
    } = field;

    fileDb.delete(value);

    this.props.form.setFieldValue(name, null);
    this.props.form.setFieldTouched(name, true);

    return null;
  }

  ButtonCheck(value) {
    if (value) {
      this.props.form.setFieldValue('check', true);
    }
    else {
      this.props.form.setFieldValue('check', false);
    }
  }

  ifDisabledSetDefaultValues(params) {
    const {
      prevProps,
    } = params;
    const {
      name,
      value,
    } = this.props.field;
    const {
      disabled,
      disabledValue,
      unDisabledValue,
    } = this.props.disabledFieldOptions;
    // check if the previous props had set it to disabled
    const prevDisabled = prevProps ? prevProps.disabledFieldOptions.disabled : false;


    if (disabledValue !== null || unDisabledValue !== null) {
      // FN: 13/01/2020
      // There's no where in create CRQ that I know of where a dropzone is disabled. However if that is ever
      // a feature, we must always set the value as null if disabled or. This is because this is a reference to
      // a file which we cannot generate in the absense of a file.
      // An exception to this would be if we set the unDisbaledValue to the previous file reference. However
      // as we may not ever need that, I'm not going to put the work into writing/testing that now
      console.warn('DISABLED AND UNDISABLED VALUES SHOULD BE NULL FOR VFDropzone');
    }


    if (!disabled) {
      if (prevDisabled) {
        this.props.form.setFieldValue(name, unDisabledValue);
        this.props.form.setFieldTouched(name, true);
      }
      return null;
    }

    if (JSON.stringify(value) !== JSON.stringify(disabledValue)) {
      this.props.form.setFieldValue(name, disabledValue);
      this.props.form.setFieldTouched(name, true);
    }
    return null;
  }


  render() {

    const {
      vFParams,
      field,
      form,
      disabledFieldOptions,
      optional,
    } = this.props;

    const {
      name,
      value,
    } = field;

    const {
      disabled,
    } = disabledFieldOptions;

    const formErrors = form.errors;
    const touched = form.touched[name];

    const errors = formErrors[name];

    const inlineErrors = errors && errors.inlineErrors ? errors.inlineErrors : null;

    const {
      fieldTitle,
      acceptedFileTypes,
      maxSize,
    } = vFParams;

    const className = `v-f-field-type v-f-dropzone v-f-dropzone-${name}`;

    const fileId = value ? value.fileId : null;
    const currentFile = fileDb.get(fileId);

    return (
      <div
        className={className}
      >
        {
          fieldTitle && (
            <FieldTitle
              fieldTitle={fieldTitle}
              optional={optional}
            />
          )
        }
        <DropzoneArea
          onFileAdded={this.onFileAdded}
          onFileRemoved={this.onFileRemoved}
          currentFile={currentFile}
          disabled={disabled}
          acceptedFileTypes={acceptedFileTypes}
          maxSize={maxSize}
          CrqID={this.state.CrqID}
          ButtonCheck={this.ButtonCheck}
          RemedyLinkPresent={this.props.form.initialValues.summary.includes(REMEDY_UPLOAD)}
        />
        {
          inlineErrors && touched && (
            <InlineErrors
              inlineErrors={inlineErrors}
            />
          )
        }
      </div>

    );
  }
}



VFDropzone.propTypes = {
  vFParams: vFParamsPropShape,
  // we have to define the value within the data structure for field
  field: getFieldPropShape(PropTypes.object),
  form: formPropShape,
  disabledFieldOptions: disabledFieldOptionsShape,
  optional: PropTypes.bool,
};


const noValueVFDropzone = (value) => value === null;
// This is a reference to the component. This is needed as the value for each form field is displayed on a change summary
// page but this is dependant on what type of form field is used
const VF_DROPZONE = 'v-f-dropzone';

export {
  VFDropzone,
  noValueVFDropzone,
  VF_DROPZONE,
};
